import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=5fdcabd7&scoped=true&"
import script from "./AudioPlayer.vue?vue&type=script&lang=js&"
export * from "./AudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=5fdcabd7&prod&lang=scss&"
import style1 from "./AudioPlayer.vue?vue&type=style&index=1&id=5fdcabd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcabd7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioPlayer/AudioPlayer.vue
// module id = 509
// module chunks = 58